
import { Link } from "react-router-dom";
import { MessageSquare, Pencil, Share2, Code, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import DeletePositDialog from "./DeletePositDialog";
import ShareDialog from "./ShareDialog";
import EmbedConfigDialog from "./EmbedConfigDialog";
import { Posit } from "@/types/posit";

interface PositActionsProps {
  positId: string;
  posit: Posit;
  isPremium: boolean;
  onDelete: () => Promise<void>;
}

const PositActions = ({ positId, posit, isPremium, onDelete }: PositActionsProps) => {
  const [showEmbedDialog, setShowEmbedDialog] = useState(false);

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2">
      <DeletePositDialog onDelete={onDelete} />
      
      <Button asChild variant="outline" size="sm">
        <Link to={`/update-posit/${positId}`}>
          <Pencil className="h-4 w-4 mr-2" />
          Edit
        </Link>
      </Button>
      
      <Button asChild variant="outline" size="sm">
        <Link to={`/chat/${positId}`}>
          <MessageSquare className="h-4 w-4 mr-2" />
          Chat
        </Link>
      </Button>

      {/* Wiki link removed: access via Settings instead */}
      
      <ShareDialog positId={positId} isPremium={isPremium} />
      
      <Button 
        variant="outline" 
        size="sm" 
        onClick={() => setShowEmbedDialog(true)}
      >
        <Code className="h-4 w-4 mr-2" />
        Embed
      </Button>

      <EmbedConfigDialog
        posit={posit}
        open={showEmbedDialog}
        onClose={() => setShowEmbedDialog(false)}
      />
    </div>
  );
};

export default PositActions;
